import { addLicense } from "@amcharts/amcharts4/core";
import React, { useEffect } from "react";
import "../../assets/styles/main.scss";
import { __chart_license__ } from "../../constants";
import "./Ariya/styles/ariyaLayout.scss";
import { CedarShellLayout } from "./CedarShell/CedarShellLayout";

interface Props {
  children: JSX.Element;
}

export const AriyaLayout = (props: Props): JSX.Element => {
  const { children } = props;

  const chartLicense = __chart_license__ || "";

  // Sets chart settings
  useEffect(() => {
    addLicense(chartLicense);
  }, []);

  return (
    <CedarShellLayout>
      <div className={`ariyaWrapper`}>
        {/* --menu_width zeroed out: that column was reserved for the old DashboardMenu, now
            replaced by CedarShellLayout's own sidenav. */}
        <div className={`dashboard noPageFilter ariya_dashboard`} id="ariyaIframe" style={{ "--menu_width": "0" } as React.CSSProperties}>
          {children}
        </div>
      </div>
    </CedarShellLayout>
  );
};
